import {useAuthUserStore} from "@/stores/auth";

/*
 * Gestión de quizzes y sus preguntas (API V2, LMS-091, rutas bajo `/v2/lms`). Las
 * respuestas de gestión incluyen las soluciones; el alumno usa otro recurso sin ellas.
 *
 * Quiz:     { uuid, title, pass_percentage, max_attempts (null = ilimitado), required_to_progress, shuffle, questions }
 * Pregunta: { uuid, type: 'single' | 'multiple', statement, explanation, position, options }
 * Opción:   { uuid?, text, is_correct, feedback }
 */
const quizUrl = (quizUuid) => '/v2/lms/quizzes/' + quizUuid
const questionsUrl = (quizUuid) => quizUrl(quizUuid) + '/questions'

const settingsPayload = (quiz) => ({
    title: quiz.title,
    pass_percentage: quiz.pass_percentage,
    max_attempts: quiz.max_attempts,
    required_to_progress: quiz.required_to_progress,
    shuffle: quiz.shuffle,
})

// Las opciones van anidadas en el mismo payload que la pregunta.
const questionPayload = (question) => ({
    type: question.type,
    statement: question.statement,
    explanation: question.explanation,
    options: question.options.map((option) => ({
        uuid: option.uuid,
        text: option.text,
        is_correct: option.is_correct,
        feedback: option.feedback,
    })),
})

export default {
    store(lessonUuid, quiz) {
        return useAuthUserStore().getApiClient.post('/v2/lms/lessons/' + lessonUuid + '/quizzes', settingsPayload(quiz))
    },
    show(quizUuid) {
        return useAuthUserStore().getApiClient.get(quizUrl(quizUuid))
    },
    update(quiz) {
        return useAuthUserStore().getApiClient.put(quizUrl(quiz.uuid), settingsPayload(quiz))
    },
    // Borra el quiz con sus preguntas y los intentos de los alumnos (204).
    destroy(quizUuid) {
        return useAuthUserStore().getApiClient.delete(quizUrl(quizUuid))
    },
    storeQuestion(quizUuid, question) {
        return useAuthUserStore().getApiClient.post(questionsUrl(quizUuid), questionPayload(question))
    },
    updateQuestion(quizUuid, question) {
        return useAuthUserStore().getApiClient.put(questionsUrl(quizUuid) + '/' + question.uuid, questionPayload(question))
    },
    destroyQuestion(quizUuid, questionUuid) {
        return useAuthUserStore().getApiClient.delete(questionsUrl(quizUuid) + '/' + questionUuid)
    },
    reorderQuestions(quizUuid, questions) {
        return useAuthUserStore().getApiClient.put(questionsUrl(quizUuid) + '/order', {
            questions: questions.map((question, index) => ({
                uuid: question.uuid,
                position: index + 1
            }))
        })
    },
}
